import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { RoutingService, UIService } from '@services';

import {
  SingleRoomControlOverlayTypeEnum,
  SingleRoomControlUrlTypeEnum,
} from '../../installation/installation-overlay.model';

@Component({
  selector: 'app-src-overlay',
  templateUrl: './src-overlay.component.html',
  styleUrls: ['./src-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SrcOverlayComponent {
  readonly singleRoomControlOverlayTypeEnum = SingleRoomControlOverlayTypeEnum;
  @Input() activeSrcOverlay: SingleRoomControlOverlayTypeEnum;
  @Input() installationId: number;
  @Input() gatewaySerial: string;
  constructor(public uiService: UIService, private routingService: RoutingService) {}

  back(): void {
    this.routingService.replaceChildPathOnUrl(SingleRoomControlUrlTypeEnum.SingleRoomControl);
    this.uiService.activeSingleRoomControlOverlay$.next(
      SingleRoomControlOverlayTypeEnum.SingleRoomControlDetails
    );
  }

  close(): void {
    this.uiService.closeActiveOverlay(this.gatewaySerial, this.installationId);
  }
}
